<template>
  <HeaderTraveller />
</template>

<script setup>
import HeaderTraveller from './HeaderTraveller'
import { getOperationNumber } from '~/helper'
import AutoOpenChat from '~/components/ui/chat/AutoOpenChat'
import { watchEffect, computed, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js'
import { useGetCookie } from '~/composables/common/useCustomCookie'
import { useCurrenciesStore } from '~/store/pinia/currencies'
import { useAuthStore } from '~/store/pinia/auth'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

// ---Define---
const route = useRoute()
const router = useRouter()
const currenciesStore = useCurrenciesStore()
const authStore = useAuthStore()
const generalStore = useGeneralInfoStore()

//const dj_curr = process.env.DEFAULT_CURRENCY_CODE || useGetCookie('dj_curr').value
const dj_curr = useGetCookie('dj_curr').value || currenciesStore.currencySelected?.code//store.state?.currenciesStore?.currencySelected?.code
const dj_curr_symbol = useGetCookie('dj_curr_symbol').value || generalStore?.detectCountryInfo?.currency_symbol
//const country_code = process.env.DEFAULT_COUNTRY_CODE || useGetCookie('country_code').value
const country_code = useGetCookie('country_code').value || generalStore?.detectCountryInfo?.country_code
//console.log('----- Header -----', country_code, dj_curr)
//const country_name = process.env.DEFAULT_COUNTRY_NAME || useGetCookie('country_name').value
const country_name = useGetCookie('country_name').value || generalStore?.detectCountryInfo?.country_name
//const region_name = process.env.DEFAULT_REGION || useGetCookie('region_name').value
const region_name = useGetCookie('region_name').value || generalStore?.detectCountryInfo?.region
//const city_name = process.env.DEFAULT_CITY || useGetCookie('city_name').value
const city_name = useGetCookie('city_name').value || generalStore?.detectCountryInfo?.city
const continent_code = useGetCookie('continent_code').value || generalStore?.detectCountryInfo?.continent_code
const continent = useGetCookie('continent').value || generalStore?.detectCountryInfo?.continent
const timezone = useGetCookie('timezone').value || generalStore?.detectCountryInfo?.timezone

// ---Computed---
const state = computed(() => generalStore.finishedChat)
const userInfo = computed(() => authStore.getUserInfo)
const detectCountryInfo = computed(() => {
  return generalStore.detectCountryInfo
})

// ---Method---
const isExistDataCookie = () => {
  // return getCookie('dj_curr') && getCookie('country_code')
  return dj_curr && country_code && continent_code
}
const setPhoneNumberByCookie = () => {
  if (isExistDataCookie()) {
    generalStore.setDetectCountryLoaded(true)
    // const countryCodeToCheck = getCookie('country_code')
    const countryCodeToCheck = country_code
    let phone = getOperationNumber(countryCodeToCheck, continent_code)
    // store.commit('generalStore/setDetectCountryInfo', {
    //   country_code: getCookie('country_code'),
    //   country_name: getCookie('country_name'),
    //   region_name: getCookie('region_name'),
    //   city_name: getCookie('city_name'),
    //   phone,
    // })
    // console.log('[setDetectCountryInfo setPhoneNumberByCookie]',phone)
    generalStore.setDetectCountryInfo({
      country_code,
      country_name,
      region: region_name,
      city: city_name,
      phone,
      continent,
      continent_code,
      currency_code: dj_curr,
      currency_symbol: dj_curr_symbol,
      timezone,
    })
    return
  }
}

// ---Watch---
watch(
  () => authStore.auth,
  (newValue) => {
    if (newValue.phone && isValidPhoneNumber(userInfo.value.phone)) {
      const countryCodeToCheck = parsePhoneNumber(userInfo.value.phone).country
      let phone = getOperationNumber(countryCodeToCheck)
      // console.log('[setDetectCountryInfo watch]',phone)
      generalStore.setDetectCountryInfo({
        ...detectCountryInfo.value,
        phone,
      })
    }
  },
  { deep: true },
)
watchEffect(() => {
  if (state.value === 'finished') {
    if (Object.keys(route.query).toString().indexOf('open_chat') !== -1) {
      let query = Object.assign({}, route.query)

      let chat_id = query.open_chat
      if (chat_id) {
        setTimeout(() => {
          AutoOpenChat(chat_id)
        }, 500)
        delete query.open_chat
      }

      router.replace({ query })
    }
  } else {
    return false
  }
})

// ---Mounted---
onMounted(() => {
  setPhoneNumberByCookie()
})
</script>

<style scoped></style>
